export default "__VITE_ASSET__CNChNSIu__"